import { fetchBasicJsonPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    sendTest: params =>
        fetchBasicJsonPost('/Sms/SendTestSms', {
            data: {
                message: params.message,
                admin_number: params.admin_number
            }
        }),
    sendToAllPatients: params =>
        fetchBasicJsonPostJson('/Sms/SendToAllPatients', {
            data: {
                message: params.message,
                admin_number: params.admin_number,
                code: params.code
            }
        })
};
